module.exports = __webpack_public_path__ + "static/media/tomato.25bb27cd.jpg";